/*global window, document, getSiblings ,setInterval, clearInterval,getElements,getElement,getNextSibling,getPrevSibling,setAttributes,getComputedStyle,pageDirection,console*/
/*jslint es6 */
/*=== Theme Customize ===*/
const heroSlider = () => {
    var heroElement = getElement('.hero-slider');
    //===== Hero Slider =====//
    if (heroElement) {
        var heroSlider = tns({
            container: heroElement,
            items: 1,
            slideBy: 'page',
            autoplay: true,
            nav:false,
            autoplayButton: false,
            autoplayButtonOutput:false,
            autoplayTimeout:7000
        });

        if (heroElement.closest('.tns-outer')) heroElement.closest('.tns-outer').classList.add('hero-slider-outer');
    }
};

//===== Services Slider =====//
const servicesPlay = () => {
    var servicesSlides = getElements('.services-slider');
    Array.from(servicesSlides).forEach(element => {
        var servicesSlider = tns({
            container: element,
            items: 1,
            slideBy: 1,
            autoplay: true,
            nav:false,
            autoplayButton: false,
            autoplayButtonOutput:false,
            autoplayTimeout:6000,
            responsive: {
                765 : {items:2},
                1024 : {items:3},
                1100 : {items:4},
            }
        });
        if(element.closest('.tns-outer')) element.closest('.tns-outer').classList.add('services-slider-outer');
    });
}

//===== Blog Slider =====//
const blogsPlay = () => {
    var blogs = getElements('.blog-slider');
    Array.from(blogs).forEach(element => {
        var blogsSlider = tns({
            container: element,
            items: 1,
            slideBy: 1,
            autoplay: true,
            nav:false,
            autoplayButton: false,
            autoplayButtonOutput:false,
            autoplayTimeout:6000,
            responsive: {
                765 : {items:2},
                1024 : {items:3},
            }
        });
        if(element.closest('.tns-outer')) element.closest('.tns-outer').classList.add('blog-slider-outer');
    });
}

//===== Blog Slider =====//
const downloadsPlay = () => {
    var downloads = getElements('.downloads-slider');
    Array.from(downloads).forEach(element => {
        var downloadsSlider = tns({
            container: element,
            items: 1,
            slideBy: 1,
            autoplay: true,
            nav:false,
            autoplayButton: false,
            autoplayButtonOutput:false,
            autoplayTimeout:6000,
            responsive: {
                765 : {items:2},
                1024 : {items:3},
                1100 : {items:4},
            }
        });
        if(element.closest('.tns-outer')) element.closest('.tns-outer').classList.add('downloads-slider-outer');
    });
}

//===== speces Slider =====//
const specesPlay = () => {
    var speces = getElements('.specializations-slider');
    Array.from(speces).forEach(element => {
        var speciSlider = tns({
            container: element,
            items: 2,
            slideBy: 1,
            autoplay: true,
            nav:false,
            autoplayButton: false,
            autoplayButtonOutput:false,
            autoplayTimeout:6000,
            responsive: {
                765 : {items:4},
                1024 : {items:5},
                1100 : {items:6},
            }
        });
        if(element.closest('.tns-outer')) element.closest('.tns-outer').classList.add('speces-slider-outer');
    });
}

//===== Services Slider =====//
const universitesPlay = () => {
    var universites = getElements('.universites-slider');
    Array.from(universites).forEach(element => {
        var universitesSlider = tns({
            container: element,
            items: 2,
            slideBy: 1,
            autoplay: true,
            nav:false,
            autoplayButton: false,
            autoplayButtonOutput:false,
            autoplayTimeout:6000,
            responsive: {
                570 : {items:3},
                765 : {items:4},
                1024 : {items:6},
                1100 : {items:7},
            }
        });
        if(element.closest('.tns-outer')) element.closest('.tns-outer').classList.add('universites-slider-outer');
    });
}

//===== Sestimonails Slider =====//
const testimonailsPlay = () => {
    var testimonails = getElements('.testimonails-slider');
    Array.from(testimonails).forEach(element => {
        var testimonailsSlider = tns({
            container: element,
            items: 1,
            slideBy: 1,
            autoplay: true,
            nav:true,
            controls:false,
            autoplayButton: false,
            autoplayButtonOutput:false,
            autoplayTimeout:6000,
            responsive: {
                1024 : {items:2},
                1190 : {items:3},
            }
        });
        if(element.closest('.tns-outer')) element.closest('.tns-outer').classList.add('testimonails-slider-outer');
    });

    //====== Testimonials Audio =======//
    const stopAudio = () => {
        var allAudios = getElements('.testimonials-block .content-box audio');
        Array.from(allAudios).forEach(audio => {
            audio.pause();
            audio.currentTime = 0;
            //======= Icon Swirch =======//
            audio.parentNode.classList.add('ti-play');
            audio.parentNode.classList.remove('ti-pause');
        });
    }

    addLiveListener('.testimonials-block .content-box','click', event => {
        event.preventDefault();
        var block = event.target;
        //======== Stop Played Audio =======//
        stopAudio();
        //======= Icon Swirch =======//
        block.classList.toggle('ti-play');
        block.classList.toggle('ti-pause');
        //======== Play Audio =======//
        var audio = block.querySelector('audio');
        audio.play();
        //======= on Ended =======//
        audio.onended = event => {
            //======= Icon Swirch =======//
            audio.parentNode.classList.add('ti-play');
            audio.parentNode.classList.remove('ti-pause');
        }
    });
}

//===== carousel Slider =====//
const carouselPlay = () => {
    var carouselSlider = getElements('.carousel-slider');
    Array.from(carouselSlider).forEach(element => {
        var carouselSlider = tns({
            container: element,
            items: 1,
            slideBy: 1,
            autoplay: true,
            nav:false,
            controls:true,
            autoplayButton: false,
            autoplayButtonOutput:false,
            autoplayTimeout:6000,
            mouseDrag:true,
            responsive: {
                475 : {items:2},
                768 : {items:3},
                1195 : {items:4},
            }
        });
        if(element.closest('.tns-outer')) element.closest('.tns-outer').classList.add('carousel-slider-outer');
    });
}

//==== Grid Tiny Slider ====//
const fixTnsGrid = () => {
    var gridTns = getElements('.tns-outer .row');
    Array.from(gridTns).forEach(function (gridTns){
        gridTns.closest('.tns-outer').classList.add('grid-tns');
    });
}

document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    //====> Icons Direction Fix <=======//
    var directionIcons = getElements('.ti-arrow-direction-c');
    Array.from(directionIcons).forEach(element => {
        element.classList.add('ti-arrow-'+startDirection+'-c');
    });

    var directionReverseIcons = getElements('.ti-arrow-dirction-reverse-c');
    Array.from(directionReverseIcons).forEach(element => {
        element.classList.add('ti-arrow-'+endDirection+'-c');
    });

    //==== Remove Archives from the Title ====//
    if (pageDirection == 'rtl') {
        var breadcrumbElements = getElements('.breadcrumb .breadcrumb_last');
        Array.from(breadcrumbElements).forEach(function (breadcrumbElement) {
            var elemTxt = breadcrumbElement.textContent;
            elemTxt = elemTxt.replace("Page", "");
            breadcrumbElement.textContent = elemTxt;
        });
    }

    /*===== Contact 7 =====*/
    var cf7_br = getElements('.wpcf7-form br');
    Array.from(cf7_br).forEach(function (cf7_br) {
        cf7_br.remove();
    });

    var directionElement = getElement('[dir]');
    if (directionElement) { directionElement.removeAttribute('dir'); }

    //====== Anti-Admin Scripts =====//
    var wpAdmin = getElement('body');
    if (!wpAdmin.classList.contains('wp-admin')) {
        heroSlider();
        testimonailsPlay();
        universitesPlay();
        specesPlay();
        blogsPlay();
        downloadsPlay();
        servicesPlay();
        carouselPlay();
        fixTnsGrid();
        //========= Disable Right Click ==========//
        document.addEventListener('contextmenu', event => event.preventDefault());
        //========= Disable Inspect Element ==========//
        document.onkeydown = function(e) {
            if(event.keyCode == 123) {return false;}
            if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {return false;}
            if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {return false;}
            if(e.ctrlKey && e.shiftKey && e.keyCode == 'c'.charCodeAt(0)) {return false;}
            if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {return false;}
            if(e.ctrlKey && e.shiftKey && e.keyCode == 'E'.charCodeAt(0)) {return false;}
            if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {return false;}
        }
    }
});